/*
 * Feelings live page — single composite poster of all 25 feelings,
 * wrapped in the same frosted-glass card chrome as the Number and
 * Weather pages so the live morning-meeting surfaces feel like
 * matched peers.
 */

.feelings {
  position: relative;
  z-index: 1;
  /* Edge + chrome clearance is handled by the live stage safe-area
   * (--token-safe-*); the page fills its safe box. */
  padding: 0;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  flex: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.empty {
  position: relative;
  z-index: 1;
  padding: var(--token-space-2xl);
  font-family: var(--token-font-ui);
}

/* Frosted-glass card. Sized to hug the poster — max-width is the
 * poster's native width (1536) plus the card's horizontal padding on
 * each side, so the gap from image edge to card edge is consistent
 * with the top/bottom padding. */
.card {
  background: rgba(255, 250, 240, 0.8);
  backdrop-filter: blur(22px) saturate(160%);
  -webkit-backdrop-filter: blur(22px) saturate(160%);
  border: 1.5px solid var(--token-accent);
  border-radius: var(--token-radius-card);
  /* +25px each side compared to the prior clamp(20-36) range, so the
   * card grows by 50px in both width and height. Gives the poster a
   * bit more breathing room from the card edges. */
  padding: 56px;
  box-shadow:
    var(--token-shadow-card),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
  /* Fixed natural size (max-content hugging the poster's fixed width below) so
   * the card never reflows with the viewport; useFitScale shrinks the whole
   * card to fit the live safe box. Centre-origin so it stays put when scaled. */
  width: max-content;
  margin: 0;
  transform-origin: center center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.title {
  margin: 0;
  font-family: var(--token-font-display);
  /* Fixed design px (the card scales as a unit via useFitScale). */
  font-size: 48px;
  letter-spacing: 0.3px;
  color: var(--token-text-primary);
  text-align: center;
  line-height: 1.1;
}

/* The poster fills the card width inside its padding, so the gap
 * from image edge to card edge matches the card padding on every
 * side (modulo the title height above the image). */
.poster {
  display: block;
  /* Fixed design width (height auto preserves the artwork's aspect). The whole
   * card is then scaled by useFitScale to fit, instead of sizing the poster off
   * the viewport (vh), which made it too big on some displays. */
  width: 1280px;
  height: auto;
  user-select: none;
  pointer-events: none;
}
